import { Assessment, ElementKind, Section } from '@playbooks/core/src/interfaces/ActionCard'

function getAllAssessments(sections: Section[]) {
  return sections.flatMap(sec => {
    return (
      sec.elements?.flatMap<Assessment>(element =>
        element.kind === ElementKind.ASSESSMENT ? (element as Assessment) : [],
      ) || []
    )
  })
}

export default getAllAssessments
